import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    authenticated: false,
    user: {},
    menu: [],
    fcm: null,
    reload: false,
    company: {
      company_name: 'Distributor Amanata',
      logo: require('@/assets/logo/Logo.png'),
      fav_icon: require('@/assets/logo/favicon.png')
    },
    color: '#DD5826',
    counter: {
      total_company_quota: 0,
      total_company_quota_used: 0,
      total_company_quota_sisa: 0
    },
    customer: {},
    order: {}
  },
  mutations: {
    setToken(state, accessToken) {
      state.token = accessToken
      state.authenticated = true
    },
    setUser(state, accessUser) {
      state.user = accessUser
    },
    setMenu(state, accessMenu) {
      state.menu = accessMenu
    },
    setFcm(state, accessFcm) {
      state.fcm = accessFcm
    },
    setReload(state, accessReload) {
      state.reload = accessReload
    },
    setCompany(state, accessCompany) {
      state.company = accessCompany
    },
    setColor(state, accessColor) {
      state.color = accessColor
    },
    setCounter(state, accessCounter) {
      state.counter = accessCounter
    },
    setCustomer(state, accessCustomer) {
      state.customer = accessCustomer
    },
    setOrder(state, accessOrder) {
      state.order = accessOrder
    }
  },
  actions: {},
  modules: {}
})